import React from 'react';

import './styles.css';

const Loader = props => {
  return <div
    className="loader"
    style={{ width: props.size, height: props.size }}
  />
}

export default Loader;